import { client } from "./index";

// Dashboard, plans, payments and the audit trail. The role always comes from the login token, never from a parameter.
export const getOverview = () => client.get("/admin/overview");
// Orders still to send out across the account's websites (the My websites badge)
export const getPendingOrders = () => client.get("/admin/overview/pending-orders");
// New orders waiting to be accepted or rejected (the ringing alarm)
export const getNewOrders = () => client.get("/admin/overview/new-orders");
// The store owner's first sign-in tour
export const getTutorial = () => client.get("/admin/tutorial");
export const finishTutorial = () => client.post("/admin/tutorial/done");
// Starter content choice (keep, manual, remove)
export const getStarterContent = () => client.get("/admin/starter-content");
// Overview: the owner's stores with no product of their own yet (the "Add your products" card)
export const getStoresWithoutProducts = () => client.get("/admin/starter-content/add-products");
export const chooseStarterContent = (siteId, choice) => client.post(`/admin/sites/${siteId}/starter-content`, { choice });
// Website editor -> "Delete in bulk": what = "samples" | "products" | "categories" | "everything"
export const clearCatalog = (siteId, what) => client.post(`/admin/sites/${siteId}/catalog/clear`, { what });
// Settings -> Configuration (Super Admin): { tutorialEnabled, freeTrialEnabled, defaultPlan }
export const getAppSettings = () => client.get("/admin/app-settings");
export const saveAppSettings = (changes) => client.put("/admin/app-settings", changes);

export const getPlans = () => client.get("/admin/plans");
export const updatePlan = (key, payload) => client.put(`/admin/plans/${key}`, payload);

export const getPayments = (params) => client.get("/admin/payments", { params });
export const getPaymentHistory = (params) => client.get("/admin/payments/history", { params });
export const confirmPayment = (paymentId, payload = {}) => client.put(`/admin/payments/${paymentId}/confirm`, payload);
export const failPayment = (paymentId) => client.put(`/admin/payments/${paymentId}/fail`);

export const getAuditLogs = (params) => client.get("/admin/audit-logs", { params });

// Super Admin SEO Command Center
export const getSeoStatus = () => client.get("/admin/seo/status");
export const reanalyzeSeo = () => client.post("/admin/seo/reanalyze");
export const getSeoBacklinks = (params) => client.get("/admin/seo/backlinks", { params });
export const toggleSeoBacklink = (id, done, data = {}) => client.post(`/admin/seo/backlinks/${id}/toggle`, { done, ...data });
export const addCustomBacklink = (payload) => client.post("/admin/seo/backlinks/custom", payload);
export const getSeoSettings = () => client.get("/admin/seo/settings");
export const updateSeoSettings = (payload) => client.put("/admin/seo/settings", payload);
export const getDaScore = () => client.get("/admin/seo/da");
export const reanalyzeDa = () => client.post("/admin/seo/da/reanalyze");
export const generateKeywordContent = (payload) => client.post("/admin/seo/keywords/generate-content", payload);
export const uploadBrandingLogo = (kind, formData) => client.post(`/admin/branding/${kind}`, formData);
